const ERROR_TRANSLATIONS: Record<string, string> = {
  // User errors
  'User not found': 'Usuario no encontrado',
  'User not found.': 'Usuario no encontrado',
  'User not found, update not done.': 'Usuario no encontrado',
  'User or profile picture not found': 'Usuario no encontrado',
  // Professional errors
  'Professional not found': 'Profesional no encontrado',
  'Professional account not found for user': 'Cuenta profesional no encontrada',
  'Profesional profile not found for user': 'Perfil profesional no encontrado',
  'Professional profile not found': 'Perfil profesional no encontrado',
  'Professional picture not found': 'Foto de perfil no encontrada',
  // Auth errors
  'Unauthorized': 'No autorizado',
  'Invalid credentials': 'Credenciales inválidas',
  'Invalid or expired token': 'Enlace inválido o expirado',
  // Job review errors
  'Job Review not found': 'Reseña no encontrada',
  'Job not found': 'Trabajo no encontrado',
  // Profession errors
  'Profession not found': 'Profesión no encontrada',
  'Professions not found': 'Profesiones no encontradas',
  // Generic errors
  'Not found': 'No encontrado',
  'Internal Server Error': 'Error interno del servidor',
  'Bad Request': 'Solicitud inválida',
  'Forbidden': 'Acceso denegado',
}

export const HTTP_STATUS_MESSAGES: Record<number, string> = {
  400: 'Solicitud inválida',
  401: 'No autorizado',
  403: 'Acceso denegado',
  404: 'No encontrado',
  408: 'La solicitud excedió el tiempo de espera',
  409: 'Conflicto con datos existentes',
  422: 'Datos no procesables',
  429: 'Demasiadas solicitudes, intenta más tarde',
  500: 'Error interno del servidor',
  502: 'Error de conexión con el servidor',
  503: 'Servicio no disponible',
  504: 'El servidor no respondió a tiempo',
}

export function translateError(message: string, statusCode?: number): string {
  if (ERROR_TRANSLATIONS[message]) {
    return ERROR_TRANSLATIONS[message]
  }

  for (const [english, spanish] of Object.entries(ERROR_TRANSLATIONS)) {
    if (message.toLowerCase().includes(english.toLowerCase())) {
      return spanish
    }
  }

  if (/[áéíóúñ¿¡]/i.test(message) || /\b(el|la|los|las|un|una|no|se|es|en)\b/i.test(message)) {
    return message
  }

  if (statusCode && HTTP_STATUS_MESSAGES[statusCode]) {
    return HTTP_STATUS_MESSAGES[statusCode]
  }

  return 'Error en la solicitud'
}
